<template>
  <v-container fluid class="mt-6 mx-7">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-axis-arrow-lock" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-movimentacao-blindada"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/movimentacaoBlindada/Parametros.vue')
    },
    mixins: [dateFormatterMixins, tourMixins],

    data: () => ({
      loading: false,
      arrTour: [
        {
          element: '#titulo-movimentacao-blindada',
          intro: 'Aqui você poderá inserir um nome para sua movimentação da blindada.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#date-picker-data-corte-ultimo-ciclo',
          intro: 'Aqui você poderá inserir a data de corte do último ciclo.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#date-picker-data-homologacao',
          intro: 'Aqui você poderá inserir a data de homologação.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#date-picker-data-atualizacao',
          intro: 'Aqui você poderá inserir o período de atualização dos dados.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#arquivo-baixas-movimentacao-blindada',
          intro: 'Aqui você poderá inserir o arquivo de baixas dos ativos que serão baixados.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-save-movimentacao-blindada',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua movimentação da blindada.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Movimentação da Blindada' : 'Adicionar Nova Movimentação da Blindada';
      }
    },

    created() {
      this.$store.dispatch('clearMovimentacaoBlindada');
    },

    mounted() {
      if (this.$route.params.id) this.getById(this.$route.params.id);
      this.iniciarTourPagina();
    },

    methods: {
      getById(id) {
        MovimentacaoBlindadaService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.data);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar movimentação da blindada.', '', {
              position: 'topRight'
            });
          });
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        MovimentacaoBlindadaService.salvar(data)
          .then(() => {
            this.$toast.success('Movimentação da blindada salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Movimentacao de Blindada Historico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar movimentação da blindada.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setMovimentacaoBlindada', {
          titulo: item.titulo,
          anoMesCorteUltimoCiclo: item.ano_mes_corte_ultimo_ciclo
            ? this.formatDateToPicker(item.ano_mes_corte_ultimo_ciclo)
            : null,
          dataHomologacao: item.data_homologacao ? this.formatDateToPicker(item.data_homologacao) : null,
          atualizarDesde: item.atualizar_desde,
          atualizarAte: this.formatDateToPicker(item.atualizar_ate),
          arquivoBaixas: item.arquivo_baixas_id
            ? {
                id: item.arquivo_baixas_id,
                fileObj: new File([''], item.arquivo_baixas.arquivo, {
                  type: 'text/csv'
                }),
                delimitador: item.arquivo_baixas_delimitador,
                involucro: item.arquivo_baixas_involucro,
                escape: item.arquivo_baixas_escape,
                fakeFile: true,
                headerValido: true
              }
            : undefined,
          arquivoIa: item.arquivo_ia_id
            ? {
                id: item.arquivo_ia_id,
                fileObj: item.arquivo_ia
                  ? new File([''], item.arquivo_ia.arquivo, {
                      type: 'text/csv'
                    })
                  : undefined,
                delimitador: item.arquivo_ia_delimitador,
                involucro: item.arquivo_ia_involucro,
                escape: item.arquivo_ia_escape
              }
            : undefined,
          origemBaixas: item.origem_baixas,
          simulacaoBaixas: item.simulacao_baixas_id
            ? {
                id: item.simulacao_baixas.id,
                nome: item.simulacao_baixas.nome
              }
            : undefined
        });

        this.$forceUpdate();
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>
